import PlainInputMasked, {
  type PlainInputMaskedProps,
  type NumberFormatValues,
  type SourceInfo,
} from './plain-input-masked'

import DealerPhoneMask from './dealer-phone-mask'
import { maskType, getPhoneMaskTypeByIsoCode } from './mask-types'

export const maskTypes = maskType // DEPRECATED

export default PlainInputMasked

export { DealerPhoneMask, maskType, getPhoneMaskTypeByIsoCode }
// TODO убрать отсюда DealerPhoneMask, он использует redux

export type { PlainInputMaskedProps, NumberFormatValues, SourceInfo }

export { PlainInputMaskedStateful } from './plain-input-masked-stateful'
export { PlainInputMaskedCustom } from './plain-input-masked-custom'
export type { PlainInputMaskedCustomProps } from './plain-input-masked-custom'

export { getPredefinedParams } from './mask-predefined'
